module.exports={
  "fields": {
    "license": {
      "title": "Licence (for uploaded maps)",
      "values": ["Copyright [no license]", "Public domain", "Public domain dedication - no rights reserved (CC0)", "Attribution (CC BY 4.0)"]
    }
  }
}
